






















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import {addDefaultValuesToStore, killNotRelevantCriteria, resetPricingPack} from "@/shared/scripts/ValidateData";
import { mapActions, mapGetters } from "vuex";
import { getSteps } from "@/encoding/scripts/steps";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    data: function() {
        return {
            pathInStore: "property.type",
        };
    },
    computed: {
        ...mapGetters({
            getValue: "FormModule/getValue",
            isReadonlyField: "FormModule/isReadonlyField",
            getFirstPublicationDate: "FormModule/getFirstPublicationDate"
        }),
        isEditionMode: function(): boolean {
            return this.$store.getters["FormModule/getIsEditionMode"];
        },
        propertyType: function(): string {
            return this.getValue(this.pathInStore);
        },
        transactionType: function(): string {
            return this.getValue("transaction.type");
        },
        applyAndResetWizard: function(): boolean {
            return this.$store.getters["ResetWizardModule/getApplyChange"]("property_type");
        },
        getMessageError: function(): string|null {
            if(this.getErrorMessage(this.pathInStore)) {
                return this.getErrorMessage(this.pathInStore);
            }
            if(this.getErrorMessage("property")){
                return this.getErrorMessage("property");
            }
            return null;
        },
        options: function(): Array<Record<string, unknown>> {
            if (this.transactionType === "FOR_SALE") {
                return [
                    {
                        "label": this.$t("undefined"),
                        "value": "",
                    },
                    {
                        "label": this.$t("house"),
                        "value": "HOUSE"
                    },
                    {
                        "label": this.$t("apartment"),
                        "value": "APARTMENT"
                    },
                    {
                        "label": this.$t("land"),
                        "value": "LAND",
                    },
                    {
                        "label": this.$t("garage"),
                        "value": "GARAGE"
                    },
                    {
                        "label": this.$t("office"),
                        "value": "OFFICE"
                    },
                    {
                        "label": this.$t("industry"),
                        "value": "INDUSTRY"
                    },
                    {
                        "label": this.$t("commercial"),
                        "value": "COMMERCIAL"
                    },
                    {
                        "label": this.$t("other"),
                        "value": "OTHER"
                    }
                ];
            } else {
                return [
                    {
                        "label": this.$t("undefined"),
                        "value": "",
                    },
                    {
                        "label": this.$t("house"),
                        "value": "HOUSE"
                    }, {
                        "label": this.$t("apartment"),
                        "value": "APARTMENT"
                    },
                    {
                        "label": this.$t("garage"),
                        "value": "GARAGE"
                    },
                    {
                        "label": this.$t("office"),
                        "value": "OFFICE"
                    },
                    {
                        "label": this.$t("business"),
                        "value": "COMMERCIAL"
                    },
                    {
                        "label": this.$t("industry"),
                        "value": "INDUSTRY"
                    },
                    {
                        "label": this.$t("other"),
                        "value": "OTHER"
                    }
                ];
            }
        },
    },
    watch: {
        transactionType: {
            handler: function(val) {
                return val;
            },
            deep: true
        },
    },
    mounted: function() {
        Vue.nextTick(() => {
            const targetElement = document.getElementById("propertyTypes") as HTMLElement;
            if (targetElement !== null) {
                targetElement.addEventListener("click", this.handleClick);
            }
        });
        this.isReadonlyField;
    },
    methods: {
        ...mapActions({
            selectPropertyType: "FormModule/setPropertyType",
            setInitialSteps: "StepsWizard/init",
            resetValidatedSteps: "StepsWizard/reset",
        }),
        handleClick: function() {
            if(this.$store.getters["StepsWizard/getIndexVisited"] > 4 && !this.applyAndResetWizard ) {
                this.$store.commit("ResetWizardModule/setField", "property_type");
                this.$store.commit("ModalModule/openResetWizardModal");
            }
        },
        updatePropertyType: function (propertyType: string) {

            // Check if propertyType is undefined, in this case we don't need to re-init the store steps-wizard
            if(this.propertyType !== propertyType && propertyType !== "") {

                let propertySubtype: string = this.getValue("property.subtype") || "";
                let transactionSubtype: string = this.getValue("transaction.subtype") || "";

                this.setInitialSteps({config: getSteps()});

                this.selectPropertyType(propertyType);

                this.killAndSetValues(propertyType, propertySubtype, this.transactionType, transactionSubtype);
                if(this.applyAndResetWizard) {
                    this.$store.commit("ResetWizardModule/setApplyChange", false);
                    this.resetValidatedSteps(["step-property-type"]);
                }
            }
        },
        killAndSetValues: async function(propertyType: string, propertySubtype: string, transactionType: string, transactionSubtype: string) {
            killNotRelevantCriteria(propertyType, propertySubtype, transactionType, transactionSubtype);
            addDefaultValuesToStore(propertyType, propertySubtype, transactionType, transactionSubtype);
            resetPricingPack();
        }
    }
});
